

const HOST_API = 'api.femijamusliman.com';
// const HOST_API = 'fm-srvc.herokuapp.com';


export  const API = 'https://' + HOST_API + '/api/'